import { IconButton, Modal, Tab } from "@mui/material";
import React, { useState, useCallback, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SubscriptionItem from "./SubscriptionItem";
import styled from "styled-components";
import Button from "../../Button";
import TextView from "../../TextView";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress, Tabs } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useGetAllSubcriptions } from "../../../services/queries";
import { SubscriptionFeatures } from "../../SubscriptionPlans/SubscriptionFeatures";
import { PlanComparison } from "../../SubscriptionPlans";
import { toast } from "react-toastify";
import { closeUpgradePopup } from "../../../redux/reducers/upgradePopup";
import { useNavigate } from "react-router-dom";
import {
  AnnualTabContainer,
  SavingsText,
  SubscriptionContainer,
  PricingContainer,
} from "../../Settings/Subscription/styles";
import UpgradeModal from "../../SubscriptionModals/UpgradeModal/UpgradeModal";
import { useSubscription } from "../../../hooks/useSubscription";
import { isChrome, isSafari } from "../../../utils/browserDetection";

const ModalContainer = styled.div`
  min-width: 750px;
  width: 85vw;
  height: 85vh;
  max-height: 800px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 10001;
`;

const ModalHeader = styled.div`
  border-bottom: 1px solid #ddd;
  padding: 24px 20px;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid #ddd;
  padding: 24px 20px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const ModalContent = styled.div`
  margin-top: 20px;
  padding: 20px;
  padding-top: 0px;
  overflow-y: scroll;
`;

export const TabContainer = styled("div")(() => ({
  display: "flex",
  gap: "10px",
  borderRadius: "100px",
  width: "320px",
  alignSelf: "center",
  backgroundColor: "#F6F7F9",

  margin: "auto",
  marginTop: 20,
}));

export const StyledTab = styled(Tab)(() => ({
  textTransform: "none !important",
  width: "160px",
  height: "30px",
  backgroundColor: "#F6F7F9",
  padding: "6px 8px",
  color: "#9A999A",
  fontSize: "14px",
  lineHeight: "20px",
  fontFamily: '"DM Sans", sans-serif',
  borderRadius: "100px",
  "&.Mui-selected": {
    backgroundColor: "#9B5AF8",
    color: "#FFFFFF !important",
    borderRadius: 100,
  },
  "&.Mui-focusVisible": {
    backgroundColor: "#9B5AF8",
  },
}));

const DiscountBadge = styled.span`
  background-color: #f5cc3b;
  padding: 8px;
  border-radius: 8px;
  width: max-content;
  font-weight: bold;
  margin-left: 5px;
  color: black;
`;

const PaymentRedirectModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000002;
`;

const PaymentModalContent = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 32px;
  max-width: 450px;
  width: 90%;
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
`;

const PaymentModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const PaymentCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f5f5f5;
  }
`;

const PaymentRedirectButton = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

// Styled components for mobile app error modal
const MobileAppModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000003;
`;

const MobileAppModalContent = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 32px;
  max-width: 550px;
  width: 90%;
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
`;

const MobileAppModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const MobileAppCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f5f5f5;
  }
`;

const MobileAppModalText = styled.div`
  margin-bottom: 24px;
  color: #666;
  line-height: 1.5;
  text-align: center;
`;

const MobileAppGoBackButton = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default function UpgradePopup() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { isOpen, from_referral, requiredSubscription } = useSelector(
    (state) => state.upgradePopup
  );

  const browserIsSafari = isSafari();

  // Use the shared subscription hook
  const {
    // Constants
    BILLING_CYCLES,

    // State
    selectedPlan,
    defaultCardId,
    showUpgradeModal,
    loading,
    comparePlan,
    features,
    packages,
    promoCode,
    discountInfo,
    codeError,
    validatingCode,

    // Utility functions
    getSubscriptionLimits,
    extractListItems,
    getSubscriptionPlans,

    // Actions
    handlePaymentMethodChange,
    handleApplyDiscountCode,
    handleActionPress,
    handleConfirmAction,
    fetchComparisonData,
    setComparePlan,
    closeAllModals,
    setPackages,
  } = useSubscription({
    enabled: isOpen,
  });

  const [value, setValue] = useState(BILLING_CYCLES.ANNUAL);
  const [loadingComparison, setLoadingComparison] = useState(false);
  const [pendingUrl, setPendingUrl] = useState(null);
  const [subscribing, setSubscribing] = useState(false);
  const [isPaymentRedirectModalOpen, setIsPaymentRedirectModalOpen] =
    useState(false);
  const [isMobileAppModalOpen, setIsMobileAppModalOpen] = useState(false);
  const {
    data: rawData,
    isLoading,
    refetch,
  } = useGetAllSubcriptions(getSubscriptionLimits(value), from_referral, {
    enabled: isOpen,
  });

  // Filter data based on required subscription tier
  const data = React.useMemo(() => {
    if (!rawData?.data?.data) return null;
    return {
      ...rawData,
      data: {
        ...rawData.data,
        data: rawData.data.data.filter(
          (item) =>
            !requiredSubscription ||
            item.sub_tier >= requiredSubscription ||
            item.is_active
        ),
      },
    };
  }, [rawData, requiredSubscription]);

  const tabs = ["Annual", "Monthly"];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setPendingUrl(null);
    setIsPaymentRedirectModalOpen(false);
    dispatch(closeUpgradePopup());
  };

  const handleOpenPaymentPage = () => {
    window.open(pendingUrl, "_blank");
    closeAllModals();
    handleClose();
  };

  const handleClosePaymentPopup = () => {
    setPendingUrl(null);
    setIsPaymentRedirectModalOpen(false);
  };

  // Custom onSuccess and onError handlers for this component
  const onSubscriptionSuccess = useCallback(
    (res) => {
      setSubscribing(false);
      if (res?.data?.data?.url) {
        // Store the URL for user to open manually to avoid popup blockers
        if (!browserIsSafari) {
          handleOpenPaymentPage();
        } else {
          setPendingUrl(res.data.data.url);
          setIsPaymentRedirectModalOpen(true);
        }
      } else {
        closeAllModals();
        handleClose();
        toast.success("Subscription updated successfully");
      }
      refetch();
    },
    [closeAllModals, handleClose, refetch]
  );

  const onSubscriptionError = useCallback((error) => {
    closeAllModals();
    console.error("Subscription error:", error);
    setSubscribing(false);

    // Check if error is about mobile app account creation
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.data?.non_field_errors?.[0];
    const isMobileAppError = errorMessage?.includes(
      "created your iYuga account on the mobile app"
    );

    if (isMobileAppError) {
      setIsMobileAppModalOpen(true);
    } else {
      toast.error("Failed to process subscription");
    }
  }, []);

  // Custom confirm handler that includes our specific callbacks
  const handleUpgradeConfirm = useCallback(
    (params = {}) => {
      setSubscribing(true);
      handleConfirmAction({
        ...params,
        onSuccess: onSubscriptionSuccess,
        onError: onSubscriptionError,
      });
    },
    [handleConfirmAction, onSubscriptionSuccess, onSubscriptionError]
  );

  const getPackageComparison = async () => {
    setLoadingComparison(true);
    try {
      const result = await fetchComparisonData({ from_referral });
      if (result) {
        // Filter packages if required
        const filteredPackages = result.packages.filter(
          (pkg) =>
            !requiredSubscription ||
            pkg.sub_tier >= requiredSubscription ||
            pkg.sub_tier == 0
        );
        setPackages(filteredPackages);
      }
      setLoadingComparison(false);
    } catch (error) {
      setLoadingComparison(false);
    }
  };

  // Handle upgrade action - adapted to use the hook's handleActionPress
  const handleUpgradeAction = (item) => {
    handleActionPress(item);
  };

  // Get plan data from the hook
  const { fromPlanData, toPlanData } = getSubscriptionPlans();

  const handleNextClick = () => {
    nav("/settings");
    localStorage.setItem("selectedTabIndex", "subscriptionsAndBilling");
    dispatch(closeUpgradePopup());
  };

  return (
    <Modal open={isOpen} onClose={handleClose} sx={{ zIndex: 1000000 }}>
      <ModalContainer>
        <div>
          <ModalHeader>
            <Row>
              <TextView variant="largeTitle">
                <AutoAwesomeIcon
                  style={{ color: " #F5CC3B", fontSize: 24, marginRight: 5 }}
                />{" "}
                {from_referral
                  ? "Upgrade for Free!"
                  : "Choose the plan to Upgrade"}
              </TextView>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Row>
            {from_referral && (
              <TextView>
                Upgrade now to join our Earnings Program! Just build, share, and
                earn.
              </TextView>
            )}
          </ModalHeader>
          <TabContainer>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="transparent"
            >
              {tabs.map((tab, index) => (
                <StyledTab
                  key={index}
                  label={
                    tab === "Annual" ? (
                      <AnnualTabContainer>
                        <span>{tab}</span>
                        <SavingsText>Savings</SavingsText>
                      </AnnualTabContainer>
                    ) : (
                      tab
                    )
                  }
                />
              ))}
            </Tabs>
          </TabContainer>
        </div>
        <ModalContent>
          {isLoading || loadingComparison ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: comparePlan ? "220px 1fr" : "1fr",
                padding: !comparePlan && "0px 40px",
                marginTop: 10,
              }}
            >
              {comparePlan && <PlanComparison features={features} />}
              <PricingContainer>
                {!isLoading &&
                  data?.data?.data.length &&
                  data.data.data.map((item) => {
                    const listItems = item.body
                      ? extractListItems(item.body)
                      : [];
                    return (
                      <SubscriptionContainer
                        key={item.id}
                        itemCount={data?.data?.data.length || 0}
                      >
                        <SubscriptionItem
                          title={item.title}
                          price={item.price}
                          listItems={listItems}
                          item={item}
                          onViewFeatures={() => getPackageComparison()}
                          onActionPress={() => handleUpgradeAction(item)}
                          showFeatures={!comparePlan}
                          isAnnually={value === BILLING_CYCLES.ANNUAL}
                        />
                        {comparePlan && (
                          <SubscriptionFeatures
                            features={features}
                            packages={packages}
                            subscription={item}
                            closeComparison={() => setComparePlan(false)}
                          />
                        )}
                      </SubscriptionContainer>
                    );
                  })}
              </PricingContainer>
            </div>
          )}
        </ModalContent>
        {subscribing && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              zIndex: 1000,
            }}
          >
            <CircularProgress />
          </div>
        )}
        <ModalFooter>
          <ButtonsContainer>
            <Button variant={"secondary"} onClick={handleClose}>
              Cancel
            </Button>
            {/* <Button onClick={handleNextClick}>Next</Button> */}
          </ButtonsContainer>
        </ModalFooter>

        {/* Payment Redirect Popup */}
        {isPaymentRedirectModalOpen && (
          <PaymentRedirectModal>
            <PaymentModalContent>
              <PaymentModalHeader>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  {" "}
                  <AutoAwesomeIcon
                    style={{ color: " #F5CC3B", fontSize: 24, marginRight: 5 }}
                  />{" "}
                  <TextView variant="subtitle">Complete Your Payment</TextView>
                </div>
                <div></div>
                <PaymentCloseButton onClick={handleClosePaymentPopup}>
                  <CloseIcon />
                </PaymentCloseButton>
              </PaymentModalHeader>
              <TextView style={{ marginBottom: "24px", color: "#666" }}>
                Your subscription is almost ready! Click the button below to
                redirect to the payment screen and complete your purchase.
              </TextView>
              <PaymentRedirectButton onClick={handleOpenPaymentPage}>
                Redirect to Payment Screen
              </PaymentRedirectButton>
            </PaymentModalContent>
          </PaymentRedirectModal>
        )}

        {/* Upgrade Modal */}
        {showUpgradeModal && selectedPlan && (
          <UpgradeModal
            open={showUpgradeModal}
            onClose={closeAllModals}
            onConfirm={handleUpgradeConfirm}
            fromPlan={fromPlanData}
            toPlan={toPlanData}
            isPendingPayment={subscribing}
            handlePaymentMethodChange={handlePaymentMethodChange}
            upgradeButtonText={
              selectedPlan.action === "UPGRADE" ? "Upgrade" : "Subscribe"
            }
            loading={subscribing}
            // isActionDisabled={!defaultCardId}
            showRefundInfo={fromPlanData?.type !== "free"}
            // Promo code props
            promoCode={promoCode}
            discountInfo={discountInfo}
            codeError={codeError}
            validatingCode={validatingCode}
            onApplyPromoCode={handleApplyDiscountCode}
          />
        )}

        {/* Mobile App Error Modal */}
        {isMobileAppModalOpen && (
          <MobileAppModal>
            <MobileAppModalContent>
              <MobileAppModalHeader>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <AutoAwesomeIcon
                    style={{ color: "#F5CC3B", fontSize: 24, marginRight: 5 }}
                  />
                  <TextView variant="subtitle">Action Required</TextView>
                </div>
                <MobileAppCloseButton
                  onClick={() => setIsMobileAppModalOpen(false)}
                >
                  <CloseIcon />
                </MobileAppCloseButton>
              </MobileAppModalHeader>
              <MobileAppModalText>
                It looks like you created your iYuga account on the{" "}
                <strong>mobile app</strong>.<br />
                Please go back to the <strong>iYuga mobile app</strong> to
                upgrade or change your plan.
              </MobileAppModalText>
              <MobileAppGoBackButton
                onClick={() => setIsMobileAppModalOpen(false)}
              >
                Go Back
              </MobileAppGoBackButton>
            </MobileAppModalContent>
          </MobileAppModal>
        )}
      </ModalContainer>
    </Modal>
  );
}
